var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title,
        width: 650,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px", color: "#fa9600" } },
          [
            _vm._v(
              "\n      *可根据系统提供的模版进行填写后在上传，也可直接进行第二步\n    "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "flex-align-center",
            staticStyle: { "margin-bottom": "10px" },
          },
          [
            _c("span", { staticClass: "title-1" }, [
              _vm._v("第一步：下载模版"),
            ]),
            _c(
              "a",
              {
                staticStyle: { "margin-left": "10px" },
                attrs: { href: _vm.templateUrl },
                on: {
                  click: function ($event) {
                    _vm.isDownload = true
                  },
                },
              },
              [_vm._v("\n        下载家校园沟通记录表\n      ")]
            ),
          ]
        ),
        _c(
          "a-upload-dragger",
          {
            attrs: {
              disabled: false,
              accept: ".doc,.docx",
              name: "file",
              "file-list": _vm.fileList,
              multiple: true,
              action: _vm.uploadAction,
              headers: _vm.tokenHeader,
            },
            on: { change: _vm.handleChange },
          },
          [
            _c(
              "p",
              { staticClass: "ant-upload-drag-icon" },
              [_c("a-icon", { attrs: { type: "inbox" } })],
              1
            ),
            _c("p", { staticClass: "ant-upload-text" }, [_vm._v("添加文件")]),
            _c("p", { staticClass: "ant-upload-hint" }, [
              _vm._v("(仅支持.doc或.docx格式的文件)"),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "title-1", staticStyle: { margin: "10px 0" } },
          [_vm._v("第二步：评估")]
        ),
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: { span: 3 },
              wrapperCol: { span: 20 },
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "班级表现" } },
              [
                _c("j-multi-select-tag", {
                  attrs: {
                    dictCode: "class_performance",
                    placeholder: "请选择班级表现",
                  },
                  model: {
                    value: _vm.form.classReflect,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "classReflect", $$v)
                    },
                    expression: "form.classReflect",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "家庭情况" } },
              [
                _c("j-multi-select-tag", {
                  attrs: {
                    dictCode: "family_case",
                    placeholder: "请选择家庭情况",
                  },
                  model: {
                    value: _vm.form.familyCondition,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "familyCondition", $$v)
                    },
                    expression: "form.familyCondition",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "备注" } },
              [
                _c("a-textarea", {
                  attrs: {
                    "auto-size": { minRows: 5, maxRows: 8 },
                    placeholder: "请输入备注",
                  },
                  model: {
                    value: _vm.form.remarks,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "remarks", $$v)
                    },
                    expression: "form.remarks",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }